"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../css/ApplePayButton.css");

var _ = require(".");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable no-useless-computed-key */
var ApplePayButton = function ApplePayButton(_ref) {
  var style = _ref.style,
      title = _ref.title,
      theme = _ref.theme,
      ariaLabel = _ref["aria-label"],
      children = _ref.children,
      extraProps = _objectWithoutProperties(_ref, ["style", "title", "theme", "aria-label", "children"]);

  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    className: "apple-pay-button apple-pay-button-".concat(theme),
    style: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center"
    }
  }, extraProps, {
    "aria-label": ariaLabel
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontFamily: "HelveticaNeue-Medium",
      fontSize: 17,
      paddingBottom: 1.7,
      paddingRight: 6,
      letterSpacing: 0,
      color: theme === "light" ? "black" : "white"
    }
  }, children), /*#__PURE__*/_react["default"].createElement(_.ApplePayIcon, {
    style: {
      width: 32 * 1.6,
      height: 13.15 * 1.6
    },
    fill: theme === "light" ? "black" : "white"
  })));
};
/* eslint-enable no-useless-computed-key */


ApplePayButton.propTypes = {
  title: _propTypes["default"].string,
  theme: _propTypes["default"].oneOf(["light", "dark"]),
  "aria-label": _propTypes["default"].string
};
ApplePayButton.defaultProps = {
  theme: "dark",
  "aria-label": "Pay with Apple Pay",
  children: "Pay with"
};
var _default = ApplePayButton;
exports["default"] = _default;